import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class DeliveryCocMaterialService {
  constructor(private http: HttpClient) {
  }

  save(id: number, form: {material: string}): Observable<any> {
    return this.http.put<any>(
      `${environment.apiv4uri}delivery/pdf/coc/document/${id}`,
      form,
    );
  }
}
